import languages from '../../locales/languages.json'

export const supportedLocales = languages
export const defaultLocale = 'en'

export function normalizeLocale(value: string | null | undefined): string | undefined {
  const code = String(value ?? '').toLowerCase().replaceAll('_', '-').split('-')[0]
  return supportedLocales.some(language => language.code === code) ? code : undefined
}

export function localeDirection(value: string): 'rtl' | 'ltr' {
  return supportedLocales.find(language => language.code === normalizeLocale(value))?.direction === 'rtl' ? 'rtl' : 'ltr'
}

export function preferredLocale(): string {
  try { return normalizeLocale(localStorage.getItem('language')) ?? defaultLocale } catch { return defaultLocale }
}
